exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body .form-group span[data-v-4339d21c]{font-size:13px;padding-top:5px;display:block;padding-left:5px;text-transform:capitalize}.modal-body .is-red[data-v-4339d21c]{color:red!important}.modal-body .is-green[data-v-4339d21c]{color:green!important}.modal-body .modal-loader[data-v-4339d21c]{width:100px}.modal-body .event__data[data-v-4339d21c]{font-style:italic!important;text-align:justify!important;text-transform:none!important}.modal-body .event_description[data-v-4339d21c]{text-align:justify!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4339d21c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/pixel-events/settingsModal.vue
// module id = IOTR
// module chunks = 0